import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'riferimentoFormat'
})
export class RiferimentoFormatPipe implements PipeTransform 
{

	transform(value: number): string {
		return this.format(value);
	}

	format(riferimento: number) {
		let result: string = '';
		if (riferimento != undefined && riferimento != null) {
			result = '#' + riferimento.toLocaleString('it-IT', { minimumIntegerDigits: 6 }).replace('.', '');
		}
		return result;
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/pipes/riferimento-format.pipe.ts